import { Controller } from "@hotwired/stimulus"

// Édition en ligne d'une valeur : Échap annule (retour à l'affichage).
export default class extends Controller {
  connect() {
    this.onKey = (event) => {
      if (event.key !== "Escape") return
      const cancel = this.element.querySelector("a.btn-link")
      if (cancel) cancel.click()
    }
    this.element.addEventListener("keydown", this.onKey)
  }

  disconnect() { this.element.removeEventListener("keydown", this.onKey) }
}
